import * as React from "react";
import { IProperty } from "@origin-digital/shared-app-context";
import { isNative } from "@origin-digital/platform-helpers";
import { ICustomerCodeV2 } from "@origin-digital/shared-app-context/dist/typings/generated/api";
import { KrakenAuthNav } from "@origin-digital/kraken-navigation";
import { LiveChat } from "../LiveChat";
import { Header } from "../Header";
import { IMenuItem } from "../Navigation/IMenuItem";
import { NavigationHeader } from "../NavigationHeader";

interface BaseAppContentProps {
  actionBar: Window["oetal"]["pageData"]["actionBar"];
  showHeader: Window["oetal"]["pageData"]["showHeader"];
  title: string;
}

interface MyAccountAppContentProps extends BaseAppContentProps {
  authenticated: boolean;
  isNative: boolean;
  customerCode?: ICustomerCodeV2;
  liveChat?: Window["oetal"]["pageData"]["liveChat"];
  nav: IMenuItem[];
  premiseId?: string;
  properties?: IProperty[];
  onSelectPremise: (premiseId: string) => void;
}

export const MyAccountAppContent: React.FC<MyAccountAppContentProps> = ({
  isNative,
  premiseId,
  properties,
  customerCode,
  liveChat,
  showHeader,
  authenticated,
  nav,
  actionBar = {},
  title,
  onSelectPremise
}) => {
  return (
    <>
      <LiveChat customerCode={customerCode} liveChat={liveChat} />
      <NavigationHeader
        showHeader={showHeader}
        authenticated={authenticated}
        customerCode={customerCode}
        nav={nav}
      />
      <Header
        title={actionBar.title || title}
        component={actionBar.component}
        hideActionBar={actionBar.hidden}
        mobilePropertySelector={actionBar.mobilePropertySelector}
        mobileNavButton={actionBar.mobileNavButton}
        onSelectPremise={onSelectPremise}
        premiseId={premiseId}
        premises={properties}
        isNative={isNative}
      />
    </>
  );
};

export const KrakenAppContent: React.FC<BaseAppContentProps> = ({
  actionBar = {},
  showHeader,
  title
}) => {
  return (
    <>
      {showHeader && <KrakenAuthNav />}

      <Header
        component={actionBar.component}
        hideActionBar={actionBar.hidden}
        isNative={isNative()}
        mobileNavButton={actionBar.mobileNavButton}
        title={actionBar.title || title}
      />
    </>
  );
};
